export const goHome = (
    pathname,
    navigate,
    reload
) => {
    if (pathname === "/") {
        reload();
        return;
    }

    navigate("/");
};
